import * as React from 'react'

import * as Sentry from '@sentry/browser'

import CrashLogo from 'modules/core/components/CrashLogo'
import errorFingerprint, { ERROR_PATTERNS } from 'modules/core/lib/errorFingerprint'

interface State {
  boundaryHit: boolean
}
/**
 * This component provides a catch-all error boundary that sends the exception to Sentry
 */

export default class SentryErrorBoundary extends React.Component<React.PropsWithChildren, State> {
  state = {
    boundaryHit: false,
  }

  static getDerivedStateFromError() {
    return {
      boundaryHit: true,
    }
  }

  // Catch all error boundary!
  componentDidCatch(error: Error, extra: Record<string, any>) {
    Sentry.withScope((scope) => {
      scope.setFingerprint(errorFingerprint(error, ERROR_PATTERNS.dataResource))
      Sentry.captureException(error, {
        extra,
      })
    })
  }

  render() {
    if (this.state.boundaryHit) return <CrashLogo isBootstrap />

    return <>{this.props.children}</>
  }
}
